/**
 * @name openWeatherMap
 * [openweathermap.org]{@link https://openweathermap.org/}
 * [api doc]{@link https://openweathermap.org/current}
 * 
 * @prop {String} Endpoint api.openweathermap.org/data/2.5/weather?id={CITY_ID}&&units=imperial&APPID={API_KEY}
 * 
 * @description
 * |- PLAN: Free plan
 * |- LIMITS
 * |  |- Threshold: 7,200 
 * |  |- Hourly forecast: 5 
 * |  |- Daily forecast: 0 
 * |  |- Calls 1min: 60 
 * 
 * Due to the nature of the API's free plan, we "cache"/store the response
 * into a cookie that we can reuse; and only call the XHR every so often.
 */
$(document).ready(()=> {
    runOpenWeather();
});


/**
 * @desc Sets a cookie to with a key & value param.
 * @function setCookie
 * @param {String} key Name of the cookie to set.
 * @param {String} value Value of the cookie.
 * @see [StackOverflow IE11 Cookie Handling]{@link https://stackoverflow.com/a/36395225/8296677}
 */
function setCookie(key, value) {
    var expires = new Date();
    expires.setHours(expires.getHours() + 8);
    // expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
    return Boolean(value);
}


/**
 * @desc Checks the current cookie's stash to match against the param.
 * @function getCookie
 * @param {String} key Name of the cookie to search for.
 * [StackOverflow IE11 Cookie Handling]{@link https://stackoverflow.com/a/36395225/8296677}
 */
function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}


/**
 * @desc Checks the cookie registry for a `weather` entry & logs 
 * a new cookie if null & runs getOpenWeather() ; if true, append to DOM.
 * @function runOpenWeather
 */
function runOpenWeather() {
    let element = document.getElementById('openWeather');
    if (getCookie('weather') && element !== null && element !== 'undefined') { // checks cookie
        //console.log('Current weather cookie already exists; expires within 8hrs.');
		let weather = getCookie('weather')
        element.innerHTML = unescape(escape(weather));
    } else {
        //console.log('No weather cookie exists; running getOpenWeather();');
        getOpenWeather();      // else, runs function
    }
}


/**
 * @func getOpenWeather
 * @param {Num} locationID City ID via http://bulk.openweathermap.org/sample/
 */
function getOpenWeather(locationID = 4164143) {
    // 4164143 = miami beach
    // api key = cb4b8bbfcb60fcf4e7b9abc693e32837
    let element = document.getElementById('openWeather');
    $.ajax({
        type: 'GET',
        url: 'https://api.openweathermap.org/data/2.5/weather',
        data: {
            id: locationID,
            units: 'imperial', // for F° instead of C°
            APPID: 'cb4b8bbfcb60fcf4e7b9abc693e32837'
        },
        dataType: 'json',
        success: data => {
            const response = `${data['main']['temp']} F°`;
            const weather = response.toString();

            if (element !== null && element !== 'undefined')
                document.getElementById('openWeather').innerHTML = unescape(escape(weather));

            setCookie('weather', weather);
        },
        error: error => {
            //console.log('Error: ' + error.status);
        }
    });
}